import { SEARCH_PARAM_KEYS } from '@/constants/auth'
import { useConfigsContext } from '@/context/ConfigsContext'
import { enableLoginStatusCheck } from '@/lib/configs'
import { getLoginStatus } from '@/services/auth'
import { useCallback } from 'react'

const { RETRY_AFTER, HTC_TOKEN, EMAIL, RETICULUM_TOKEN } = SEARCH_PARAM_KEYS

const useCheckLoginStatus = (onLogout?: () => void) => {
  const { store, removeStore } = useConfigsContext()
  const htcToken = store?.credentials?.htcToken

  return useCallback(
    async (qs: URLSearchParams) => {
      if (!enableLoginStatusCheck()) {
        return
      }
      const res = await getLoginStatus()

      if (res.data) {
        qs.set(RETRY_AFTER, res.data[RETRY_AFTER].toString())
        qs.set(HTC_TOKEN, res.data[HTC_TOKEN])
        qs.set(EMAIL, res.data[EMAIL])
        qs.set(RETICULUM_TOKEN, res.data[RETICULUM_TOKEN])
      } else if (htcToken) {
        removeStore()
        if (res.status !== 204) {
          onLogout?.()
        }
      }
    },
    [htcToken, removeStore, onLogout],
  )
}

export default useCheckLoginStatus
